// extracted by mini-css-extract-plugin
export default {"list":"LinkList_list__-oOhD","item":"LinkList_item__BBZjh","link":"LinkList_link__iDKCj"};